var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5C0 0.223858 0.223858 0 0.5 0H8.32408C8.45671 0 8.58391 0.0526964 8.67768 0.146493L15.3996 6.87019C15.7842 7.25714 16 7.78057 16 8.32613C16 8.87169 15.7842 9.39511 15.3996 9.78206L15.3986 9.78312L9.78889 15.3943C9.59714 15.5863 9.36941 15.7386 9.11874 15.8426C8.86806 15.9465 8.59936 16 8.32799 16C8.05663 16 7.78792 15.9465 7.53725 15.8426C7.28665 15.7386 7.05898 15.5864 6.86726 15.3944C6.8672 15.3944 6.86731 15.3945 6.86726 15.3944L0.146606 8.67984C0.0527405 8.58606 0 8.45881 0 8.32613V0.5ZM1 1V8.11889L7.57428 14.6872C7.67318 14.7863 7.79102 14.8652 7.92027 14.9188C8.04953 14.9724 8.18807 15 8.32799 15C8.46791 15 8.60645 14.9724 8.73571 14.9188C8.86497 14.8652 8.9824 14.7867 9.0813 14.6876L14.6903 9.07716C14.6905 9.07698 14.6901 9.07733 14.6903 9.07716C14.8883 8.87764 15 8.60734 15 8.32613C15 8.04489 14.8888 7.77509 14.6908 7.57556C14.6906 7.57541 14.6909 7.57572 14.6908 7.57556L8.11693 1H1ZM3.5 4C3.5 3.72386 3.72386 3.5 4 3.5H4.00782C4.28397 3.5 4.50782 3.72386 4.50782 4C4.50782 4.27614 4.28397 4.5 4.00782 4.5H4C3.72386 4.5 3.5 4.27614 3.5 4Z",
    fill: "#77798B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.c9efd10f89c5aa86a0a5e2caf74be34d.svg";
export { ForwardRef as ReactComponent };